var _circle, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconRestartCircle = function SvgIconRestartCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 12,
    transform: "matrix(1 0 0 -1 12 12)",
    fill: "#6498D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.156 9.29359C16.592 8.15324 15.6772 7.22375 14.546 6.64159C13.4229 6.06494 12.1424 5.87021 10.8987 6.08692C9.65106 6.30625 8.50804 6.92373 7.64067 7.84693C6.76525 8.77882 6.20787 9.96429 6.04867 11.2329C5.88697 12.5044 6.13053 13.7946 6.74467 14.9196C7.35316 16.036 8.30406 16.9276 9.45733 17.4629C10.6029 17.9935 11.8902 18.1358 13.124 17.8683C14.3573 17.6009 15.368 16.9929 16.204 16.0316C16.3047 15.9249 16.694 15.4943 17.0173 14.8443",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0459 14.7901L17.4059 14.1855L17.9999 17.6055",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconRestartCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_restart_circle.53677db3.svg";
export { ForwardRef as ReactComponent };